import { FC, Fragment, ReactNode } from "react";
import { Divider, Stack, Typography } from "@mui/material";

import { Dates } from "../../../../../../../../../services/cloudchipr.api";
import { SourceDataChipProps } from "../../../../../widgets/common/widget-header/source-and-name/SourceDataChip";
import { WidgetSourceInfoV2 } from "../../../../../widgets/common/widget-header/source-and-name/WidgetSourceInfoV2";

interface WidgetSetupSubHeaderV2Props {
  name: string;
  icon: "pie" | "list";
  dates: Dates;
  title: string;
  menuTitle: ReactNode;
  menuUrl: string;
  grouping?: string;
}

export const WidgetSetupSubHeaderV2: FC<WidgetSetupSubHeaderV2Props> = ({
  icon,
  name,
  title,
  menuTitle,
  menuUrl,
  grouping,
  dates,
}) => {
  const widgetSourceData: SourceDataChipProps = {
    icon,
    title,
    menu: [
      {
        url: menuUrl,
        title: menuTitle,
      },
    ],
  };

  return (
    <Fragment>
      <Stack px={2} py={1}>
        <Typography variant="body1" fontWeight="bold" minHeight={24}>
          {name}
        </Typography>

        <WidgetSourceInfoV2
          dates={dates}
          sourceData={widgetSourceData}
          grouping={grouping}
        />
      </Stack>

      <Divider />
    </Fragment>
  );
};
